import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import i18n from '../i18n/config';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className="border-b border-[#3498db]/20 py-4">
      <button
        className="flex justify-between items-center w-full text-left focus:outline-none group"
        onClick={onToggle}
      >
        <h3 className="text-lg font-medium text-[#2c3e50] group-hover:text-[#3498db] transition-colors duration-200">{question}</h3>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-[#1abc9c]" />
        ) : (
          <ChevronDown className="h-5 w-5 text-[#3498db]" />
        )}
      </button>
      {isOpen && (
        <div className="mt-2 text-[#2c3e50]/80">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

const Faq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems = [
    {
      question: i18n.t('faq.eligibility.question'),
      answer: i18n.t('faq.eligibility.answer'),
    },
    {
      question: i18n.t('faq.requirements.question'),
      answer: i18n.t('faq.requirements.answer'),
    },
    {
      question: i18n.t('faq.process.question'),
      answer: i18n.t('faq.process.answer'),
    },
    {
      question: i18n.t('faq.timeframe.question'),
      answer: i18n.t('faq.timeframe.answer'),
    },
  ];

  return (
    <section id="faq" className="py-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-[#2c3e50] sm:text-4xl">
            {i18n.t('faq.title')}
          </h2>
          <p className="mt-4 text-lg text-[#2c3e50]/80">
            {i18n.t('faq.subtitle')}
          </p>
        </div>

        <div className="space-y-4 bg-white rounded-lg shadow-lg p-6 border border-[#3498db]/10">
          {faqItems.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#2c3e50]/80">
            {i18n.t('faq.contact_text')}
          </p>
          <a
            href="/contact"
            className="mt-4 inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#3498db] hover:bg-[#2980b9] transition-colors duration-200"
          >
            {i18n.t('contact.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Faq; 